import { jsx as _jsx } from "react/jsx-runtime";
if (process.env.NODE_ENV === "development") {
    require("preact/devtools");
}
import SyntheticSiteDashboard from "../../speedcurve-components/src/pages/SyntheticSiteDashboard";
import installSpeedCurveRumHooks from "../../speedcurve-components/src/lib/speedcurve-rum-hooks";
import renderDashboard from "../../speedcurve-components/src/lib/render-dashboard";
import "../../speedcurve-components/src/style/global.scss";
installSpeedCurveRumHooks();
renderDashboard(_jsx(SyntheticSiteDashboard, { pageLabelsBySite: window.SPEEDCURVE_SYN_SITE.pageLabelsBySite }));
